// Nook and Wave: local pickup on the product page (the user, 2026-10-31). Shopify's Liquid lists a finish's pickup
// stores only for the finish SELECTED (?variant=), so the page is rendered with the selected finish's stores exact
// and every other finish that holds stock marked "to confirm": this fetches each one's stores once
// (sections/nw-pickup-info.liquid, cached for the page) and then shows its Pickup badge on the finish tile and the
// "or pick up at <store> in <finish>" line under the lead-time eyebrow, which selects that finish when clicked.
// A finish change morphs the variant picker only (the theme's variant-picker.js), so the eyebrow is refreshed here
// from the document the picker fetched (the product-select event's promise), as Shopify's own local-pickup.js does.
import { StandardEvents } from '@shopify/events';

const cache = new Map();

function storesOf(url, id) {
  if (!cache.has(id)) {
    const u = `${url.split('?')[0]}?variant=${encodeURIComponent(id)}&section_id=nw-pickup-info`;
    cache.set(
      id,
      fetch(u, { credentials: 'same-origin' })
        .then((r) => (r.ok ? r.text() : ''))
        .then((t) => {
          const m = t.match(/<script[^>]*id="nw-pickup-info"[^>]*>([\s\S]*?)<\/script>/);
          const j = m ? JSON.parse(m[1]) : null;
          return j && String(j.variant) === String(id) && Array.isArray(j.stores) ? j.stores : [];
        })
        .catch(() => [])
    );
  }
  return cache.get(id);
}

function lower(s) {
  return String(s || '').replace(/^Usually/, 'usually');
}

function apply() {
  const wrap = document.querySelector('[data-nw-avail]');
  const url = wrap?.dataset.productUrl || location.pathname;
  wrap?.querySelectorAll('[data-nw-pick-variant]').forEach((btn) => {
    storesOf(url, btn.dataset.nwPickVariant).then((list) => {
      const s = list[0];
      if (!s || !btn.isConnected) return;
      const where = btn.querySelector('[data-nw-pick-where]');
      const when = btn.querySelector('[data-nw-pick-time]');
      if (where) where.textContent = s.name;
      if (when) when.textContent = lower(s.time);
      btn.hidden = false;
      const line = btn.closest('.nw-avail-pickup');
      if (line) line.hidden = false;
    });
  });
  document.querySelectorAll('[data-nw-pickup-badge][hidden]').forEach((b) => {
    storesOf(url, b.dataset.nwPickupBadge).then((list) => {
      const s = list[0];
      if (!s || !b.isConnected) return;
      b.title = `Pick up at ${s.name} · ${lower(s.time)}`;
      b.hidden = false;
    });
  });
}

// the line's click: select that finish in the picker (its radio input), the picker does the rest
document.addEventListener('click', (e) => {
  const btn = e.target instanceof Element ? e.target.closest('[data-nw-pick-variant]') : null;
  if (!btn) return;
  const input = document.querySelector(`variant-picker input[data-variant-id="${btn.dataset.nwPickVariant}"]`);
  if (!(input instanceof HTMLInputElement) || input.checked) return;
  input.click();
  input.closest('fieldset')?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
});

// after a finish change: the eyebrow from the fetched document, then the badges and the line again (cached, instant)
document.addEventListener(
  StandardEvents.productSelect,
  (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
    const p = event.promise;
    if (!p || typeof p.then !== 'function') return;
    p.then(({ detail } = {}) => {
      const html = detail?.html;
      const fresh = html?.querySelector?.('[data-nw-avail]');
      const wrap = document.querySelector('[data-nw-avail]');
      if (fresh && wrap) {
        wrap.innerHTML = fresh.innerHTML;
        wrap.dataset.variant = fresh.dataset.variant || '';
      }
      apply();
    }).catch(() => {});
  },
  true
);

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply);
else apply();
